import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "components/home/hero"
import Stack from "components/home/stack"
import Steps from "components/home/steps"
import Info from "components/home/info"
// import Testimonials from "components/home/testimonials"
import Values from "components/home/values"

const IndexPage = () => (
  <Layout buttonText={"Deploy a cluster"} isLight>
    <SEO
      title="WoodCore is a lightweight cloud banking platform that enables fintech, digital banks."
      description="WoodCore is a lightweight cloud banking platform that enables fintech, digital banks, and payment service providers to create their own products requiring banking capabilities, or to integrate such capabilities into their systems, apps. and workflows."
    />

    <Hero />
    <section>
      <div className="w-11/12 md:w-10/12 xl:w-8/12 mx-auto pb-10 md:pb-24 py-24">
        <div className="mb-10">
          <div className=" w-11/12 lg:w-10/12 mx-auto">
            <h3
              className="text-grey-100 font-semibold"
              style={{ fontSize: "43px", lineHeight: "60px" }}
            >
              We’re the global leading expert in deploying enterprise and core
              banking services
            </h3>
            <p
              className="text-grey-200 mt-4 text-lg w-11/12"
              style={{ fontSize: "16.7px", lineHeight: "30px" }}
            >
              We offer the most flexible and lightweight core banking
              application, built for to scale with 99% optimal server
              performance. This means that, in less than 24 hours we can convert
              your idea into reality.
            </p>
            <p
              className="text-grey-200 mt-4  w-11/12"
              style={{ fontSize: "16.7px", lineHeight: "30px" }}
            >
              WoodCore provides you with a banking infrastructure where you can
              build your service. With over 600 API resources for performing all
              forms of banking activities. From account management, branch,
              loans, fixed deposit, recurring deposits, reporting as well as
              settlement mechanisms all in a box.
            </p>
          </div>
        </div>
      </div>
    </section>
    <Stack />
    <Steps />
    <Info />
    {/* <Testimonials /> */}
    <Values />
  </Layout>
)

export default IndexPage
